import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table'
import { Badge } from '@/components/ui/badge'
import { Button } from '@/components/ui/button'
import { X } from 'lucide-react'
import type { TeamInvitation } from '@/types/team-members'
import { ORG_ROLE_LABELS } from '@/types/team-members'
import { formatDistanceToNow } from 'date-fns'

interface PendingInvitationsTableProps {
  invitations: TeamInvitation[]
  onCancel: (invitationId: string) => void
  isLoading?: boolean
  isCancelling?: string | null
}

export function PendingInvitationsTable({
  invitations,
  onCancel,
  isLoading = false,
  isCancelling = null,
}: PendingInvitationsTableProps) {
  if (isLoading) {
    return (
      <div className="flex justify-center items-center h-24">
        <p className="text-sm text-muted-foreground">Loading invitations...</p>
      </div>
    )
  }

  if (invitations.length === 0) {
    return (
      <div className="flex justify-center items-center h-24">
        <p className="text-sm text-muted-foreground">
          No pending invitations
        </p>
      </div>
    )
  }

  return (
    <div className="border rounded-lg">
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>Email</TableHead>
            <TableHead>Role</TableHead>
            <TableHead>Invited</TableHead>
            <TableHead className="text-right">Actions</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {invitations.map((invitation) => (
            <TableRow key={invitation.id}>
              <TableCell className="font-medium">{invitation.email}</TableCell>
              <TableCell>
                <Badge variant="outline">
                  {ORG_ROLE_LABELS[invitation.role]}
                </Badge>
              </TableCell>
              <TableCell className="text-sm text-muted-foreground">
                {invitation.created_at
                  ? formatDistanceToNow(new Date(invitation.created_at), {
                      addSuffix: true,
                    })
                  : 'N/A'}
              </TableCell>
              <TableCell className="text-right">
                <Button
                  variant="ghost"
                  size="sm"
                  onClick={() => onCancel(invitation.id)}
                  disabled={isCancelling === invitation.id}
                >
                  {isCancelling === invitation.id ? (
                    <span className="text-xs">Cancelling...</span>
                  ) : (
                    <X className="h-4 w-4" />
                  )}
                </Button>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  )
}
